import type { BalanceActivity, BalanceEntry } from '@/types';
import { formatCurrency } from '@/lib/payments';

/** Member balance rules (the server enforces them; the UI only shows them). */
export const BALANCE_RATE = 0.12; // 12% per year on what is left, added monthly

/** Validation message for a balance repayment, or '' when the amount is fine. */
export const getBalancePaymentError = (amount: string, balanceDue: number): string => {
  if (!amount) return 'Please enter amount';
  const value = Number(amount);
  if (!(value >= 1)) return 'Please enter a valid amount';
  if (value > balanceDue) return `Amount cannot be more than the balance ${formatCurrency(balanceDue)}`;
  return '';
};

/** A repayment clears unpaid interest first, then the balance. */
export const splitBalancePayment = (amount: number, interestDue: number) => {
  const toInterest = Math.min(amount, interestDue);
  return { toInterest, toPrincipal: amount - toInterest };
};

/** One line describing a balance entry or the last activity, e.g. "Paid by PMS · P3301". */
export const describeBalanceActivity = (activity: Pick<BalanceActivity | BalanceEntry, 'kind' | 'source' | 'refNo' | 'amount' | 'paymentType'>) => {
  if (activity.kind === 'add') return 'Paid by PMS';
  if (activity.source === 'policy_close') return 'Deducted at policy close';
  return `Repaid ${formatCurrency(activity.amount)} · ${activity.paymentType ?? ''}`.trim();
};
